import translations from "../../translations/uk.json";
I18n.store(translations);
